import { useEffect } from 'react';
import QueryString from 'query-string';
import { ReqGet } from '../config/Requests';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { loginInitiated } from '../store/authentication/reducer';
// import { push } from 'connected-react-router';

function CallBackPopUp(props) {
	const isAuth = useSelector(state => state.auth.isSuccess);
	const initiated = useSelector(state => state.auth.isInitiated);
	const dispatch = useDispatch();

	const loginUserDispatcher = (values, loginFromSocialMedia) => {
		dispatch(loginInitiated(values, loginFromSocialMedia));
	};

	// const push = path => dispatch(push(path));

	useEffect(() => {
		const params = QueryString.parse(window.location.search);
		if (params.error) {
			const errorMessage =
				params.error_description || 'Login failed. Please try again.';
			window.opener &&
				window.opener.postMessage(
					{
						error: params.error,
						state: params.state,
						errorMessage,
						from: 'Linked In',
					},
					window.location.origin
				);
			if (params.error === 'user_cancelled_login') {
				window.close();
			}
		}
		if (params.oauth_token) {
			ReqGet(`callback/twitter${window.location.search}`)
				.then(res => {
					if (res.data.accessToken) {
						loginUserDispatcher(res, true)
							.then(() => {
								// props.push('/');
							})
							.catch(() => {
								toast.error('Email or Password is Incorrect!');
							});
					}
					if (res.data.error) {
						toast.error(res.data.message);
					}
				})
				.catch(err => {
					console.log(err.message);
				});
		}
	}, []);
	return null;
}

export default CallBackPopUp;
